import { nioJsBridge as Unsafe_NioJsBridge } from '@nio-fe/nio-js-bridge'
import { nioJsBridge, constant } from '@nio-wad/universal-bridge-h5'
import { currentPage } from '@/routes'

const dsBridge = window.dsBridge

// 返回键是否默认表现
let backActionEnable = false

const nativeHybrid = {
	isWeapp() {
		return navigator.userAgent.includes('miniProgram')
	},
	isCNLg() {
		const isLg = navigator.userAgent.includes('lg _dsbridge')

		return isLg && /NioAppCN|ALPSCN|FYCN/i.test(navigator.userAgent)
	},

	isCNDo() {
		return !this.isCNLg() && window.dsBridge && window.dsBridge.hasNativeMethod('common.showToast')
	},

	isInWebview() {
		if (this.isCNLg() || this.isCNDo() || this.isWeapp()) {
			return true
		}
		return false
	},
	isHarmony() {
		return window.navigator.userAgent.indexOf('ArkWeb') > -1;
	},

	/**
	 * 判断当前 APP 类型：NIO｜ALPS
	 */
	getAppType() {
		if (/NioAppCN/i.test(navigator.userAgent)) {
			return 'NIO'
		}
		if (/ALPSCN/i.test(navigator.userAgent)) {
			return 'ALPS'
		}
		if (/FYCN/i.test(navigator.userAgent)) {
			return 'FY'
		}

		let appName = 'NIO'
		try {
			const query = parseURLTool()
			switch (query.channel) {
				case 'alps':
					appName = 'ALPS'
					break
				case 'fy':
					appName = 'FY'
					break
			}
		} catch (e) {
			console.log('getAppType error:', e)
		}
		return appName
	},

	async getOSInfo() {
		if (!this.isInWebview()) return {}
		const result = await nioJsBridge.getOSInfo()
		return result.data || {}
	},
	isIOS() {
		return osInfo && (osInfo.systemName || '').toLowerCase() === 'ios'
	},
	async replace(url) {
		return await nioJsBridge.replace({
			data: {
				url
			}
		})
	},
	async openURL(url) {
		return await nioJsBridge.openURL({
			data: {
				url
			}
		})
	},
	// TODO
	// async openPDF(url) {
	//   const result = await nioJsBridge.openPDF({
	//     data: {
	//       url
	//     }
	//   });
	// },
	// 预览pdf
	async openPDF(viewUrl) {
		const isIOS = this.isIOS()
		try {
			if (this.isInWebview()) {
				const isHTML = viewUrl && viewUrl.includes('.html')
				if (isIOS || isHTML) {
					nioJsBridge.openURL({
						data: {
							url: viewUrl
						}
					})
					return
				}
				nioJsBridge.openPDF({
					data: {
						url: viewUrl
					},
					callback: resData => {
						console.log('openPDF callback', resData)
					}
				})
			}
		} catch (error) {
			console.log(`openPDF: ${error}`)
		}
	},
	async makeCall(tel) {
		await nioJsBridge.makeCall({
			data: {
				tel
			}
		})
	},
	async closeSyn() {
		await nioJsBridge.close()
	},
	async showToast(content) {
		await nioJsBridge.showToast({
			data: {
				content
			}
		})
	},
	async getCopyText(content = '') {
		await nioJsBridge.setCopyText({
			data: {
				content
			}
		})
	},
	async showLoading() {
		await nioJsBridge.showLoading({
			data: {
				content: ''
			}
		})
	},
	async hideLoading() {
		await nioJsBridge.hideLoading({})
	},
	async openLoginPage(callback) {
		const result = await nioJsBridge.openLoginPage()
		if (result.result_code === 'success') {
			callback
		}
	},
	async disableWebviewPull() {
		if (!this.isInWebview()) return
		await nioJsBridge.iosToggleBounces({
			data: {
				enable: false
			}
		})
	},
	async getUserInfo() {
		if (!this.isInWebview()) {
			return {}
		}
		const result = await nioJsBridge.getUserInfo()
		return result.data || {}
	},
	// 获取当前环境 env，必须是同步的，不能异步 -> 使用 dsBridge 获取
	getAppInfo() {
		if (this.isInWebview()) {
			const { result_code, data } = dsBridge.call('getAppInfo') || {}

			if (result_code === 'success' && data) {
				return data
			}
			return {}
		}
		return {}
	},

	async registerAppear() {
		await nioJsBridge.register({
			event: constant.EVENT.ON_APPEAR,
			data: {},
			callback: res => {
				currentPage && currentPage.onAppear && currentPage.onAppear(res)
			}
		})
	},

	async registerKeyboardStateChange(changeCallback) {
		await nioJsBridge.register({
			event: 'ON_KEYBOARD_STATE_CHANGE',
			data: {},
			callback: function(res) {
				if (res.data) {
					const { keyboardHeight, isShowKeyBoard } = res.data
					if (isShowKeyBoard) {
						changeCallback(keyboardHeight)
					} else {
						changeCallback(0)
					}
				}
			}
		})
	},
	share2(context) {
		return nioJsBridge.share2(context);
	},

	getSafeInsetTop() {
		if (this.isInWebview()) {
			if (this.isCNLg()) {
				if (osInfo && osInfo.safeAreaInsets) {
					const top = +osInfo.safeAreaInsets.top
					const isAndroid = !this.isIOS()

					return isAndroid ? top / window.devicePixelRatio : top
				}
			}

			if (this.isCNDo()) {
				if (osInfo && osInfo.device_type === 'ios' && osInfo.is_iphonex_type) {
					return 44
				}
			}

			return 20
		}

		return 0
	},
	getSafeInsetBottom(hardware) {
		if (this.isInWebview()) {
			if (this.isCNDo()) {
				if (osInfo && osInfo.device_type === 'ios') {
					if (osInfo.is_iphonex_type) {
						return 25
					}
					return 0
				}
			} else if (this.isCNLg()) {
				if (!hardware && !this.isIOS()) {
					return 0
				}

				// 新版bridge
				if (osInfo && osInfo.safeAreaInsets) {
					let bottomHeight = +osInfo.safeAreaInsets.bottom
					const isAndroid = !this.isIOS()
					bottomHeight = isAndroid ? bottomHeight / window.devicePixelRatio : bottomHeight

					return bottomHeight
				}
			}

			const $pix = document.createElement('div')
			Object.assign($pix.style, {
				position: 'fixed',
				top: `env(safe-area-inset-bottom)`
			})
			document.body.append($pix)

			return $pix.getBoundingClientRect().top
		}

		// 外部浏览器,一律为10
		return 10
	},
	async registerOnNetWorkChange(cb) {
		if (!this.isInWebview()) return
		await nioJsBridge.register({
			event: 'ON_NET_WORK_CHANGE',
			data: {},
			callback: context => {
				cb(context.data.status)
			}
		})
	},
	isWideScreen() {
		if (this.isInWebview()) {
		  const { data } = dsBridge.call('getOSInfo') || {};
		  const isIOS = (data && data.systemName || "").toLowerCase() === "ios";
	
		  if (isIOS) {
			console.log("isWideScreen false");
			return false;
		  }
		  const result = dsBridge.call("isWideScreen") || {};
	
		  return result && result.data === "true";
		}
		return window.innerWidth > 500 || window.innerHeight / window.innerWidth < 1.5;
	},
}

let osInfo
export async function initOSInfo() {
	osInfo = await nativeHybrid.getOSInfo()
}
export function getOSInfo() {
	return osInfo
}

let userInfo
export async function initUserInfo() {
	userInfo = await nativeHybrid.getUserInfo()
}
export function getUserInfo() {
	return userInfo
}

// 这些数据后面很多地方会同步使用，必须在 render 之前初始化完成
export async function initNativeAsyncData() {
	try {
		await initOSInfo()
		await initUserInfo()
	} catch (e) {
		console.log('initNativeAsyncData error', e)
	}
}

export default nativeHybrid
